import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IWeddingVenue, IWeddingVenueInitialState } from "./weddingVenueModel";
import {
  ActiveInactiveWeddingVenue,
  WeddingVenueDetailsImageUpload,
  createWeddingVenue,
  deleteWeddingVenue,
  deleteWeddingVenueImage,
  getAllActiveWeddingVenues,
  getAllWeddingVenues,
  getWeddingVenueByID,
  updateWeddingVenue,
} from "./services/weddingVenue.services";

const initialState: IWeddingVenueInitialState = {
  loading: false,
  formLoading: false,
  weddingVenueImageLoading: false,
  error: "",
  WeddingVenueID: null,
  WeddingVenueImageID: null,
  WeddingVenueList: [],
  WeddingVenueDetail: {
    ID: null,
    Title: "",
    URL: "",
    Tagline: "",
    Capacity: "",
    ShortDescription: "",
    LongDescription: "",
    PackageHighlights: "",
    Inclusion: "",
    Exclusion: "",
    MetaTitle: "",
    MetaDescription: "",
    MetaKeywords: "",
    IsActive: 1,
  },
};

const weddingVenueSlice = createSlice({
  name: "weddingVenue",
  initialState,
  reducers: {
    clearWeddingVenueDetails: (state) => {
      state.WeddingVenueDetail = initialState.WeddingVenueDetail;
    },
    setWeddingVenueID: (state, action) => {
      state.WeddingVenueID = action.payload;
    },
    clearWeddingVenueID: (state) => {
      state.WeddingVenueID = initialState.WeddingVenueID;
    },
    setWeddingVenueImageID: (state, action) => {
      state.WeddingVenueImageID = action.payload;
    },
    clearWeddingVenueImageID: (state) => {
      state.WeddingVenueImageID = initialState.WeddingVenueImageID;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllWeddingVenues.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllWeddingVenues.fulfilled,
      (state, action: PayloadAction<IWeddingVenue[]>) => {
        state.loading = false;
        state.WeddingVenueList = action.payload || [];
      },
    );
    builder.addCase(getAllWeddingVenues.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WeddingVenueList = [];
    });
    builder.addCase(createWeddingVenue.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(createWeddingVenue.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(createWeddingVenue.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(updateWeddingVenue.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(updateWeddingVenue.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(updateWeddingVenue.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(deleteWeddingVenue.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteWeddingVenue.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteWeddingVenue.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getWeddingVenueByID.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(getWeddingVenueByID.fulfilled, (state, action: any) => {
      state.loading = false;
      state.WeddingVenueDetail = action.payload;
    });
    builder.addCase(getWeddingVenueByID.rejected, (state, action) => {
      state.loading = false;
      state.WeddingVenueDetail = initialState.WeddingVenueDetail;
      state.error = action.error.message || "Something went wrong";
    });
    builder.addCase(getAllActiveWeddingVenues.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveWeddingVenues.fulfilled,
      (state, action: PayloadAction<IWeddingVenue[]>) => {
        state.loading = false;
        state.WeddingVenueList = action.payload || [];
      },
    );
    builder.addCase(getAllActiveWeddingVenues.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.WeddingVenueList = [];
    });
    builder.addCase(ActiveInactiveWeddingVenue.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(ActiveInactiveWeddingVenue.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(ActiveInactiveWeddingVenue.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    // IMAGE UPLOAD
    builder.addCase(WeddingVenueDetailsImageUpload.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(WeddingVenueDetailsImageUpload.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(
      WeddingVenueDetailsImageUpload.rejected,
      (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      },
    );

    builder.addCase(deleteWeddingVenueImage.pending, (state) => {
      state.weddingVenueImageLoading = true;
      state.error = "";
    });
    builder.addCase(deleteWeddingVenueImage.fulfilled, (state) => {
      state.weddingVenueImageLoading = false;
    });
    builder.addCase(deleteWeddingVenueImage.rejected, (state, action) => {
      state.weddingVenueImageLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const {
  clearWeddingVenueDetails,
  clearWeddingVenueID,
  setWeddingVenueID,
  setWeddingVenueImageID,
  clearWeddingVenueImageID,
} = weddingVenueSlice.actions;
export default weddingVenueSlice.reducer;
